import "./index.scss";

import { Stack, TextField, TextFieldProps } from "@mui/material";
import { DesktopDatePicker as MUIDatePicker } from "@mui/x-date-pickers/";
import { DatePicker as MyDatePicker } from "@mui/x-date-pickers/";
import { ReactComponent as CalendarIcon } from "assets/images/icons/calendar.svg";
import { ReactComponent as CalendarDisabledIcon } from "assets/images/icons/calendar-disabled.svg";
import Input from "components/Input";
import { parseISO } from "date-fns";
import { formatDate } from "helpers/utils";
import {
  FC,
  JSXElementConstructor,
  memo,
  ReactElement,
  useCallback,
  useEffect,
  useState,
} from "react";
import { toast } from "react-toastify";

interface DatePickerProps {
  fullWidth?: boolean;
  hasError?: any;
  showOnlyYear?: boolean;
  onChange: (value: any, keyboardInputValue?: string) => void;
  label?: string;
  className?: string;
  views?: string[];
  value?: string | Date;
  maxDate?: any;
  minDate?: any;
  disabled?: boolean;
}

const DatePickerComponent: FC<DatePickerProps> = (props) => {
  const {
    fullWidth,
    hasError,
    showOnlyYear = false,
    onChange,
    label,
    value,
    maxDate,
    minDate,
    disabled,
  } = props;
  const [internalValue, setInternalValue] = useState<Date | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (value) {
      setInternalValue(new Date(value));
    }
  }, [value]);

  return (
    <MUIDatePicker
      format="MM/dd/yyyy"
      label={label}
      value={internalValue}
      onChange={(newValue) => {
        //console.log(`newValue is ${newValue}`);
        if (showOnlyYear) {
          let formattedDate = formatDate(`${newValue}`, "DD-MM-YYYY", "YYYY");
          newValue = new Date(formattedDate !== "Invalid Date" ? formattedDate : newValue);
        }
        onChange(newValue);
        setInternalValue(newValue);
      }}
    />
  );
};

const DatePicker = memo(DatePickerComponent);
export default DatePicker;
